import { useRef, useEffect } from 'react';
export function useDeviationChangedCallback(deviation, callback) {
    const previousDeviationId = useRef(undefined);
    const currentDeviationId = deviation && deviation.deviationId;
    useEffect(()=>{
        if (deviation && currentDeviationId !== previousDeviationId.current) {
            callback(deviation);
        }
        previousDeviationId.current = currentDeviationId;
    }, [
        currentDeviationId,
        callback,
        deviation
    ]);
}

//# sourceMappingURL=useDeviationChangedCallback.js.map